import { config } from 'src/config/config'
import { apiCall } from 'src/utils/networking'

export const api = {
  searchItems: async ({ searchInput }) =>
    apiCall(`${config.baseAPIUrl}/task/search?q=${searchInput}&page=1`, {
      method: 'POST',
    }),
}
